import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toTop() {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }
}
